import constate from "constate";
import { useIsOpenState } from "hooks/useIsOpenState";
import { type TicketModel } from "models/TicketModel";
import { useState } from "react";

const useRedirectModal = () => {
  const [ticket, setTicket] = useState<null | TicketModel>(null);
  const { close, isOpen, open, setIsOpen } = useIsOpenState();

  return { actions: { close, open, setIsOpen, setTicket }, state: { isOpen, ticket } };
};

export const [RedirectModalProvider, useRedirectModalContext] = constate(useRedirectModal);
